import { StyleSheet } from 'react-native';
import { SELECTED_CHANNEL_IMAGE_SIZE } from '@shared/scenes/channel/create/components/styles';
import { Colors } from '@shared/styles/colors';

export const Styles = StyleSheet.create({
  iconNormal: {
    width: 48,
    height: 48,
    padding: 12,
  },
  iconSmall: {
    width: 24,
    height: 24,
    padding: 4,
  },
  iconLarge: {
    width: 64,
    height: 64,
    padding: 12,
  },
  boxedIconSmall: {
    borderRadius: 12,
    padding: 0,
  },
  boxedIconNormal: {
    borderRadius: 24,
    padding: 5,
  },
  boxedIconLarge: {
    borderRadius: 32,
    padding: 5,
  },
  noPadding: {
    padding: 0,
  },
  channelImage: {
    width: 48,
    height: 48,
    borderRadius: 24,
    overflow: 'hidden',
    borderColor: Colors.v2.gray50_25,
    borderWidth: 1,
  },
  channelImageSmall: {
    width: 24,
    height: 24,
    borderRadius: 12,
    overflow: 'hidden',
  },
  channelImageLarge: {
    width: SELECTED_CHANNEL_IMAGE_SIZE,
    height: SELECTED_CHANNEL_IMAGE_SIZE,
    borderRadius: SELECTED_CHANNEL_IMAGE_SIZE / 2,
    overflow: 'hidden',
  },
  businessImage: {
    width: 98,
    height: 98,
    borderRadius: 98 / 2,
    overflow: 'hidden',
  },
  userNormal: {
    width: 44,
    height: 44,
  },
  userSmall: {
    width: 24,
    height: 24,
  },
  collageNormal: {
    borderRadius: 22,
    overflow: 'hidden',
  },
  collageSmall: {
    borderRadius: 12,
    overflow: 'hidden',
  },

  userPlaceholderTextLarge: { fontSize: 28 },
  userPlaceholderTextSmall: { fontSize: 10 },
  userPlaceholderTextTiny: { fontSize: 7 },
});
